<div class="shadow-box">
  <div class="mid-block" [ngStyle]="{backgroundImage: 'url(' + encodeUrl(activity.photoUrl) + ')'}">
    <mat-chip *ngIf="displayChip && activity.inviteStatus" [ngStyle]="{backgroundColor: chipColor}"
      class="mat-chip-custom mat-chip-rsvp">
      {{chipValue}}
    </mat-chip>
    <div *ngIf="centerButton" class="center-button">
      <app-button styleType="secondary" [buttonStyle]="{backgroundColor: 'rgba(255, 255, 255, 0.9)'}"
        (click)="cbClicked($event)">{{centerButton}}</app-button>
    </div>
    <div *ngIf="activity.signatureName || (activity.signatureId && activity.signatureId != 0) || activity.signatureFlag"
      class="signature-block">
      <i class="fas fa-star"></i>
      <span translate="lblSignatureActivityTC">Signature
        Activity</span>
    </div>
  </div>
  <div class="text-block">
    <h3 class="text-crop">{{activity.activityName}}</h3>
    <div style="font-size:x-small; font-weight:bolder"><strong><span translate="lblCreator">Creator:</span>
        {{activity.organizerName}}</strong></div>
    <span>{{activity.activityCompanyName}}<br /></span>

    <div class="float-left">
      <span>{{(activity.startDate | actualDate) | date:'mediumDate'}}</span><span *ngIf="endDate"> -
        {{(activity.endDate | actualDate) |
        date:'mediumDate'}}</span>
    </div>
    <div class="float-right" *ngIf="displayStatus" style="position:absolute; right: 10px;bottom:5px">
      <mat-chip class="mat-chip-custom mat-chip-status" [ngStyle]="{backgroundColor: statusColor}"
        (click)="doActionLabel()" *ngIf="actionLabel != 'Active'">{{actionLabel}}</mat-chip>
    </div>
    <!--  <p class="action-label" (click)="doActionLabel()">{{actionLabel}}</p> -->
  </div>
</div>